<template>
  <!-- 新建部门 15 -->
  <el-dialog :title="$t('15')" :close-on-click-modal="false" :visible.sync="visible" append-to-body>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="150px">
      <el-form-item :label="$t('783')" prop="department_name">
        <el-input v-model="dataForm.department_name" :placeholder="$t('785')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('17')" prop="ancestry_id">
        <el-popover v-model="popover" ref="orgPopover" placement="bottom-start" trigger="click">
          <dep-tree v-if="popover" @node-click="handleNodeClick"></dep-tree>
        </el-popover>
        <!-- 上级部门可选 -->
        <el-input
          v-model="dataForm.ancestry_name"
          v-popover:orgPopover
          :readonly="true"
          :placeholder="$t('786')"
          v-show="state"
        ></el-input>
        <!-- 上级部门不可选 -->
        <el-input
          v-show="!state"
          v-model="dataForm.ancestry_name"
          :readonly="true"
          :placeholder="$t('786')"
          :disabled="true"
        ></el-input>
      </el-form-item>
      <!-- 部门负责人 -->
      <el-form-item :label="$t('16')">
        <el-select
          v-model="dataForm.supervisor_id"
          filterable
          remote
          reserve-keyword
          :placeholder="$t('90')"
          :remote-method="remoteMethod"
          :loading="selectLoading"
          clearable
        >
          <el-option
            class="res"
            v-for="item in supervisorOptions"
            :key="item.staff_id"
            :label="item.staff_name"
            :value="item.staff_id"
          >
            <img
              class="user-photo"
              style="vertical-align: middle"
              :src="item.avatar_url || getAvatar(item.sex || 0)"
              alt=""
            />
            <div class="name">
              <p>{{ item.staff_name }}</p>
              <p class="name_en" v-if="item.staff_name_en">{{ item.staff_name_secondary }}</p>
            </div>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" plain @click="dataFormSubmit" :disabled="disabled">
        {{ $t('131') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { searchStaffFn } from 'api/org/per'
import { createFn } from 'api/org/dep'
import depTree from '@/components/dep-tree'
import { getAvatar } from '@/util/util'

const dataForm = {
  department_name: '', // 部门名称
  ancestry_id: '', // 上级部门id
  supervisor_id: '', // 负责人id
  ancestry_name: '' // 上级部门name
}

export default {
  props: ['state'],
  components: {
    depTree
  },
  data() {
    return {
      info: {},
      visible: false,
      disabled: false,
      popover: false,
      selectLoading: false,
      supervisorOptions: [],
      dataForm,
      dataRule: {
        department_name: [
          {
            required: true,
            message: this.$t('785')
          }
        ],
        ancestry_id: [
          {
            required: true,
            message: this.$t('786')
          }
        ],
        supervisor_id: [
          {
            required: true,
            message: this.$t('787')
          }
        ]
      },
      parentNode: {}
    }
  },
  watch: {
    visible(v) {
      if (!v) {
        this.dataForm.ancestry_name = ''
        this.$refs.dataForm.resetFields()
      }
    }
  },
  methods: {
    // 生成员工头像姓名
    getAvatar,
    init(info) {
      this.info = info
      this.visible = true
      this.dataForm = JSON.parse(JSON.stringify(dataForm))
      this.$nextTick(() => {
        this.dataForm.ancestry_id = info.id
        this.dataForm.ancestry_name = info.department_name
        this.parentNode = info
        this.$nextTick(() => this.$refs.dataForm.clearValidate())
      })
    },
    handleNodeClick(val) {
      this.dataForm.ancestry_name = val.department_name
      this.dataForm.ancestry_id = val.department_id
      this.parentNode = val
      this.popover = false
    },
    remoteMethod(query) {
      if (query !== '') {
        this.selectLoading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          searchStaffFn({
            search_name: query,
            page_size: 20,
            data_privilege: 1
          }).then(res => {
            this.selectLoading = false
            if (res && res.code === 1) {
              this.supervisorOptions = res.data.map(v => ({
                avatar_url: v.avatar_url,
                staff_name: v.staff_name,
                staff_name_secondary: v.staff_name_secondary,
                staff_name_en: v.staff_name_en,
                staff_id: v.staff_id
              }))
            }
          })
        }, 300)
      } else {
        this.supervisorOptions = []
      }
    },
    dataFormSubmit() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.disabled = true
          createFn({
            ...this.dataForm,
            department_id: this.info.department_id
          })
            .then(res => {
              this.disabled = false
              if (res && res.code === 1) {
                this.visible = false
                this.$emit(
                  'refreshTreeList',
                  {
                    department_name: this.dataForm.department_name,
                    department_id: res.data.department_id,
                    is_sub_department: true
                  },
                  this.parentNode
                )
                this.$message.success(res.message)
              }
            })
            .catch(() => {
              this.disabled = false
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.res {
  min-width: 320px;
  height: 50px;
  line-height: 50px;
  display: flex;
  align-items: center;
  .name {
    padding: 4px 0 4px 8px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    p {
      line-height: 20px;
    }
  }
  .name_en {
    font-size: 12px;
    color: #8c8c8c;
  }
  /deep/.el-input {
    min-width: 320px;
  }
}
</style>
